module.exports = __webpack_public_path__ + "2b219a915f3ad345db4de9af8f4d685b.jpg";